<!--new desing-->

<!--VISTA DESCRIPCION DEL JOURNEY - RUTA DE APRENDIZAJE -->
<!--PARTE 1 BANNER -->

<div class="mx-auto max-w-7xl w-full pt-[50px] md:pt-6">
  <!-- ===== BANNER ===== -->
  <div class="w-full relative overflow-hidden md:rounded-3xl shadow-2xl"
    style="background: linear-gradient(135deg, #0a192f 0%, #0e1f3a 30%, #162a45 60%, #1b3250 100%); ">

    <!-- SVG pattern overlay (left) -->
    <div class="absolute inset-0 overflow-hidden w-3/5">
      <svg class="absolute inset-0 w-full h-full opacity-10" viewBox="0 0 600 400" fill="none" stroke="#00E5FF">
        <g stroke-width="0.5">
          <line x1="50" y1="80" x2="200" y2="150" />
          <line x1="200" y1="150" x2="350" y2="90" />
          <line x1="350" y1="90" x2="500" y2="200" />
          <line x1="100" y1="250" x2="250" y2="180" />
          <line x1="250" y1="180" x2="400" y2="300" />
        </g>
        <g fill="#00E5FF">
          <circle cx="50" cy="80" r="2.5" opacity="0.6" />
          <circle cx="200" cy="150" r="3" opacity="0.8" />
          <circle cx="250" cy="180" r="3.5" opacity="0.9" />
        </g>
      </svg>
      <div class="absolute inset-0 opacity-5"
        style="background-image: radial-gradient(circle, #00E5FF 1px, transparent 1px); background-size: 24px 24px;">
      </div>
    </div>

    <!-- Journey image (right, fade from left) -->
    <div class="absolute right-0 top-0 bottom-0 hidden lg:block w-[48%]"
      [style.background-image]="'url(' + getUrl(journey.picture) + ')'"
      style="background-size: cover; background-position: center;    mask-image: linear-gradient(to right, transparent 0%, rgba(0, 0, 0, 0.3) 25%, rgba(0, 0, 0, 0.65) 60%, rgba(0, 0, 0, 0.8) 100%); mask-image: linear-gradient(to right, transparent, black 60%);">
    </div>

    <!-- Imagen journey - solo móvil, fondo completo con baja opacidad -->
    <div class="absolute inset-0 block lg:hidden opacity-10"
      [style.background-image]="'url(' + getUrl(journey.picture) + ')'"
      style="background-size: cover; background-position: center top;">
    </div>

    <!-- Banner content -->
    <div class="relative z-10 px-5 lg:px-10 py-6 lg:py-10 flex flex-col justify-between min-h-[260px] lg:min-h-[340px] gap-4 lg:gap-0">

      <!-- Breadcrumb + type -->
      <div class="w-fit flex items-center gap-1.5 text-xs ">
        <button type="button" (click)="goBack()" aria-label="Volver atrás"
          class="shrink-0 text-white/70 hover:text-white transition-colors">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <line x1="19" y1="12" x2="5" y2="12"></line>
            <polyline points="12 19 5 12 12 5"></polyline>
          </svg>
        </button>
        <span class="text-white/70 whitespace-nowrap bg-slate-800/60 px-3 py-1 rounded-full backdrop-blur-sm ">{{ 'words.traject' | translate }}</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          class="w-3 h-3 text-white/40">
          <path d="m9 18 6-6-6-6"></path>
        </svg>
        <span class="text-white/70 whitespace-nowrap max-w-[calc(100vw-8rem)] lg:max-w-[420px]  truncate" title="{{ journey.title }}">{{ journey?.provider?.name || company?.name }} — {{ journey.title }}</span>
      </div>

      <!-- Title + description + progress -->
      <div class="max-w-2xl flex flex-col justify-center gap-2" *ngIf="!journey.isSkeleton; else bannerSkeletonTpl">
        <h1 class="text-xl lg:text-3xl font-bold text-white leading-tight line-clamp-2">{{ journey.title || ('words.untitled'
          | translate) }}</h1>
        <div class="journey-description ">
          <p class="inner-html text-xs lg:text-sm text-white/80 leading-relaxed mb-2 lg:mb-4 line-clamp-2"
            [innerHTML]="journey.description ? (journey.description | firstSentence | safe:'html') : ('words.undescribed-content' | translate)">
          </p>
        </div>
        <!-- Progress bar -->
        <div class="flex flex-col gap-3 max-w-xl">
          <div class="flex items-center gap-3">
            <div class="flex-1 h-2.5 md:h-2 bg-white/20 rounded-full overflow-hidden">
              <div class="h-full rounded-full bg-progress-gradient" [style.width]="journeyProgress + '%'"></div>
            </div>
            <span class="hidden md:inline text-xs text-white/60 whitespace-nowrap">{{ journeyProgress }}% {{'words.total-progress' | translate}}  </span>
          </div>
          <span class="mobile-only-progress-label text-[10px] text-white/60 uppercase tracking-wider font-semibold">{{ journeyProgress }}% {{'words.total-progress' | translate}}</span>
        </div>
      </div>

      <!-- Skeleton del banner mientras journey es el placeholder (ver JourneyProvider.skeletonJourney()) -->
      <ng-template #bannerSkeletonTpl>
        <div class="max-w-2xl flex flex-col justify-center gap-3 animate-pulse">
          <div class="h-7 lg:h-9 w-3/4 rounded bg-white/20"></div>
          <div class="h-4 w-full rounded bg-white/15"></div>
          <div class="h-4 w-1/2 rounded bg-white/15"></div>
        </div>
      </ng-template>

      <!-- CTA + stats -->
      <div class="flex items-center gap-6 flex-wrap">
        <div class="flex items-center gap-6 flex-wrap">
          <button *ngIf="!journey.subscribed && !courseSessionFull && !journeyIsFull" [disabled]="!journey.subscribable"
            [class.pointer-events-none]="journey.isSkeleton"
            (click)="checkSubscription()"
            class="flex items-center justify-center gap-2 w-full lg:w-auto px-6 py-2.5 lg:py-2 rounded-full bg-white text-gray-800 lg:bg-white/10 lg:text-white hover:bg-white/90 lg:hover:bg-white/20 backdrop-blur-md text-sm font-semibold transition-all">
            {{'words.start' | translate}}
            <svg class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <circle cx="12" cy="12" r="10" stroke-width="1.5"></circle>
              <polygon points="10,8 16,12 10,16" fill="currentColor"></polygon>
            </svg>
          </button>

          <div class="hidden lg:flex items-center gap-4 text-white/80 text-sm flex-wrap">
            <span [tooltip]="'funnel.adoption.signed-up' | translate" class="flex items-center gap-1"
              *ngIf="journey?.subscribedUsers">
              <i class="fas fa-user text-xs"></i>
              {{ journey.subscribedUsers }}
            </span>
            <span [tooltip]="'studio.create.course.duration' | translate" class="flex items-center gap-1"
              *ngIf="journey.duration">
              <i class="fa-regular fa-clock text-xs"></i>
              {{ convertSecondsToHoursMinutes(journey.duration) }}
            </span>
            <span [tooltip]="'words.valoration' | translate" class="flex items-center gap-1 text-yellow-400 opacity-80"
              [tooltip]="ratingInfo?.totalRatingsFull">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="w-4 h-4 text-yellow-400">
                <path
                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                </path>
              </svg>
              {{ ratingInfo?.avgRating || 0 }}
              <span class="text-white/60 text-xs">({{ ratingInfo?.totalRatingsCompact || 0 }} {{'words.valoration' |
                translate}})</span>
            </span>
          </div>

          <!-- Rating modal (invisible, needed for functionality) -->
          <app-rating-modal #ratingModal (ratingSubmitted)="handleRating($event)"></app-rating-modal>
        </div>
      </div>

    </div>
  </div>
</div>


<msc-learn-detail-journey-summary [journey]="journey" [ratingInfo]="ratingInfo" [saved]="saved"
  [courseSessionFull]="courseSessionFull" [journeyIsFull]="journeyIsFull" [sendingMessage]="sendingMessage"
  (subscribeRequested)="checkSubscription()" (unsubscribeRequested)="modalDelete.open($event)"
  (saveToggled)="changeLearnLaterContent()" (contactUsRequested)="notifyAdmin()"
  (rateRequested)="ratingModal.open(ratingInfo)">
</msc-learn-detail-journey-summary>

<msc-card-manager-modal-delete-subscription #modalDelete type="traject" (onSave)="deleteContent($event)">
</msc-card-manager-modal-delete-subscription>